import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BusyService} from 'projects//paid_ukr/src/app/services/busy.service';
import {PromoHandlerService} from '../../../../../shared/src/lib/components/promo-handler/promo-handler.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {environment} from '../../../../../free/src/environments/environment';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {AiAssistantService} from '../../../../../shared/src/lib/components/ai-assistant/ai-assistant.service';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
    plan: any;
    discountValue = null;

    form: FormGroup;
    loading = false;
    error = null;
    apiUrl = environment.apiUrl;

    codeApplyed = false;
    isUpdate = false;
    isAiSubscription = false;
    promoCodeId = null;

    constructor(
        public activeModal: NgbActiveModal,
        private busy: BusyService,
        private promoHandler: PromoHandlerService,
        private fb: FormBuilder,
        public auth: AuthService,
        private aiService: AiAssistantService
    ) {
    }

    ngOnInit(): void {
        this.isAiSubscription = this.aiService.isAiSubscription
        this.form = this.fb.group({
            promoCode: [null, Validators.required]
        });
        this.form.valueChanges.subscribe(() => {
            this.codeApplyed = false;
            this.error = null;
        });
    }

    applyPromo() {
        this.loading = true;
        this.promoHandler.applyPromo({
            plan_id: this.plan.id,
            discount_id: this.form.get('promoCode').value
        }, this.apiUrl)
            .subscribe((res) => {
                this.promoCodeId = this.form.get('promoCode').value;
                this.codeApplyed = true;
                const data = JSON.parse(res);
                this.discountValue = (this.plan.value - (this.plan.value * data.discount)).toFixed(2);
                this.loading = false;
                this.error = null;
            }, (err) => {
                this.promoCodeId = null;
                const error = JSON.parse(err.error);
                this.loading = false;
                this.discountValue = null;
                if (error && typeof error?.detail !== 'undefined') {
                    this.error = this.translateError(error?.detail);
                }
            });
    }

    translateError(error: string) {
        switch (error) {
            case 'discount-not-found':
                return 'Такого промокода не існує';
        }
    }

    onClose() {
        this.busy.setState(false);
        this.activeModal.close(false);
    }

    submit() {
        this.activeModal.close({discount_id: this.promoCodeId});
    }

}
